import { render } from "./CourseButton.vue?vue&type=template&id=7f0400b0&scoped=true"
import script from "./CourseButton.vue?vue&type=script&lang=js"
export * from "./CourseButton.vue?vue&type=script&lang=js"

import "./CourseButton.vue?vue&type=style&index=0&id=7f0400b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f0400b0"

export default script